import {Profil} from './securite.model';

export class Register {
    id: number;
    username: string;
    telephone: string;
    email: string;
    password: string;
    // tslint:disable-next-line:variable-name
    role_id: number;
    type_user: string;

    constructor(username: string, telephone: string, email: string, password: string, role: number,type_user: string) {
        this.username = username;
        this.telephone = telephone;
        this.email = email;
        this.password = password;
        this.role_id = role;
        this.type_user = type_user;
    }

}
export class Logger {
    email: string;
    password: string;
    constructor( email: string, password: string) {
        this.email = email;
        this.password = password;
    }

}
export class AuthResponse {
    code: number;
    message: string;
    success: boolean;
    authorisation: {
        token: string;
        type: string;
    };
    user: User;
}
export class User {
    id: number;
    id_u_sgiv?: string;
    nom_u_sgiv?: string;
    prenoms_u_sgiv?: string;
    login_u_sgiv?: string;
    passe_u_sgiv?: string;
    username: string;
    telephone: string;
    email: string;
    email_verified_at: any;
    role_id: number;
    created_at: string;
    updated_at: string;
    user_etap?: UserEtap
    fichiers: Fichier[]
    cv_docs: Fichier[]
    pid_docs: Fichier[]
    diplome_docs: Fichier[]
    role: Role;

    profils?: Profil[] = [];
    permissions?: string[] = [];

    constructor() {
        // let cv_doc = 'cv';
        // let card_id_doc = 'card_id';
        // console.log("fichiers",this.fichiers);
        // for (const doc of this.fichiers) {
        //     if (doc.module.toLowerCase()==cv_doc.toLowerCase()){
        //         this.cv_docs.push(doc);
        //     };
        //     if (doc.module==card_id_doc){
        //         this.pid_docs.push(doc);
        //
        //     };
        //
        // }
    }
}

export class Appareil {
    id: number;
    user_id?: number | null;
    status: string;
    device_id: string;
    description: string;
    code_activation: string;
    date_last_connexion: string;
    created_at: string;
    updated_at: string;
    user?: User | null; // 👈 ajouter la relation User

    constructor(data?: Partial<Appareil>) {
        Object.assign(this, data);
    }

    // Optionnel : méthode pour savoir si l'appareil est actif
    isActif(): boolean {
        return this.status === 'A';
    }

    // Optionnel : méthode pour savoir si l'appareil est en attente
    isEnAttente(): boolean {
        return this.status === 'E';
    }
    isInactif(): boolean {
        return this.status === 'I';
    }
}

export interface Fichier {
    id: number
    name: string
    module: string
    url: string
    extension: string
    user_id: number
    created_at: string
    updated_at: string
}

export interface Role {
    id: number;
    titre: string;
    niveau: number;
    created_at: string;
    updated_at: string;
}


export class UserEtap {
    profil_is_valide: boolean
    is_candidat: boolean
    has_profile: boolean
    has_demande: boolean
    has_candidature: boolean
}

export class Otp {
    id: number;
    telephone: string;
    code: string;
    created_at: string;
    updated_at: string;
}

export class ActivityLog {
    id: number;
    user_id: number;
    auteur_nom: string;
    action: string;
    action_label: string;
    module: string;
    endpoint: string;
    methode_http: string;
    entite_type: string;
    entite_id: number;
    entite_label: string;
    donnees_avant: any;
    donnees_apres: any;
    ip_address: string;
    user_agent: string;
    statut: string;
    message_erreur: string;
    created_at: string;
}

export class ActivityLogStats {
    total_aujourd_hui: number;
    total_ce_mois: number;
    operations_par_module: { [key: string]: number };
    top_utilisateurs: { user_id: number; auteur_nom: string; total: number }[];
    derniers_echecs: ActivityLog[];
}

// Client API machine-to-machine (SysClient).
// Le couple d'authentification transmis aux consommateurs est CLIENTID = id + APIKEY = apikey.
// `code` est un libellé technique interne, immuable, jamais envoyé dans un header.
export class SysClient {
    id: number;
    code: string;
    nom: string;
    apikey: string;
    created_at: string;
    updated_at: string;
}
